import { render } from "./TitleSubtitle.vue?vue&type=template&id=608f4dd7"
import script from "./TitleSubtitle.vue?vue&type=script&lang=js"
export * from "./TitleSubtitle.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/provider-frontend/provider-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__